import { apiFetch } from './apiFetch';

export interface StaffMember {
  arbox_users_boxes_id: number;
  display_name: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  user_role: string | null;
}

export async function listStaffMembers(): Promise<StaffMember[]> {
  return apiFetch<StaffMember[]>('/staff-members');
}

/** On-demand roster re-sync from Arbox (for newly-added staff). */
export async function refreshStaffMembers(): Promise<StaffMember[]> {
  return apiFetch<StaffMember[]>('/staff-members/refresh', { method: 'POST' });
}
